import Vue from 'vue';
import types from '../../mutation-types';

export const mutations = {
  [types.SET_CONTACT_UI_FLAG]($state, data) {
    $state.uiFlags = {
      ...$state.uiFlags,
      ...data,
    };
  },

  [types.SET_CONTACT_INBOX_FETCH_FLAG]: ($state, { id, isFetching }) => {
    Vue.set($state.uiFlags, 'contactableInboxesFetching', {
      ...$state.uiFlags.contactableInboxesFetching,
      [id]: isFetching,
    });
  },

  [types.SET_CONTACT_INBOX_FAILED_FLAG]: ($state, { id, failed }) => {
    Vue.set($state.uiFlags, 'contactableInboxesFailed', {
      ...$state.uiFlags.contactableInboxesFailed,
      [id]: failed,
    });
  },

  [types.CLEAR_CONTACTS]: $state => {
    Vue.set($state, 'records', {});
    Vue.set($state, 'sortOrder', []);
  },

  [types.CLEAR_REPORTS]: $state => {
    Vue.set($state, 'reports', {});
    Vue.set($state, 'sortOrder', []);
  },

  [types.SET_CONTACT_META]: ($state, data) => {
    const {
      totalCount = 0,
      count,
      current_page: currentPage,
      perPage = 10,
    } = data;

    Vue.set($state.meta, 'totalCount', totalCount);
    Vue.set($state.meta, 'currentPage', currentPage);
    Vue.set($state.meta, 'count', count);
    Vue.set($state.meta, 'perPage', perPage);
  },

  [types.SET_REPORT_META]: ($state, data) => {
    const { totalCount = 0, count, currentPage, perPage = 10 } = data;

    Vue.set($state.reportmeta, 'totalCount', totalCount);
    Vue.set($state.reportmeta, 'currentPage', currentPage);
    Vue.set($state.reportmeta, 'count', count);
    Vue.set($state.reportmeta, 'perPage', perPage);
  },

  [types.SET_CONTACTS]: ($state, data) => {
    const sortOrder = data.map(contact => {
      Vue.set($state.records, contact.id, {
        ...($state.records[contact.id] || {}),
        ...contact,
      });
      return contact.id;
    });
    $state.sortOrder = sortOrder;
  },

  [types.SET_REPORTS]: ($state, data) => {
    const sortOrder = data.map(contact => {
      Vue.set($state.reports, contact.id, {
        ...($state.reports[contact.id] || {}),
        ...contact,
      });
      return contact.id;
    });
    $state.sortOrder = sortOrder;
  },

  [types.SET_CONTACT_ITEM]: ($state, data) => {
    Vue.set($state.records, data.id, {
      ...($state.records[data.id] || {}),
      ...data,
    });

    if (!$state.sortOrder.includes(data.id)) {
      $state.sortOrder.push(data.id);
    }
  },

  [types.EDIT_CONTACT]: ($state, data) => {
    // Merge instead of replacing the whole record: contact updates arriving via
    // pubsub (e.g. `contact.updated` after a conversation is resolved) are often
    // partial payloads. Replacing wiped UI-only fields like `contactableInboxes`,
    // which left the New Conversation modal with an empty inbox dropdown.
    Vue.set($state.records, data.id, {
      ...($state.records[data.id] || {}),
      ...data,
    });
  },

  [types.DELETE_CONTACT]: ($state, id) => {
    const index = $state.sortOrder.findIndex(item => item === id);
    Vue.delete($state.sortOrder, index);
    Vue.delete($state.records, id);
  },

  [types.UPDATE_CONTACTS_PRESENCE]: ($state, data) => {
    Object.values($state.records).forEach(element => {
      const availabilityStatus = data[element.id];
      if (availabilityStatus) {
        Vue.set(
          $state.records[element.id],
          'availability_status',
          availabilityStatus
        );
      } else {
        Vue.delete($state.records[element.id], 'availability_status');
      }
    });
  },

  [types.SET_CONTACT_FILTERS](_state, data) {
    _state.appliedFilters = data;
  },

  [types.CLEAR_CONTACT_FILTERS](_state) {
    _state.appliedFilters = [];
  },
};
